import axios from '../axiosConfig'
import { createMessage } from './messages'
import {
  FETCH_OFERTAS_WEB,
  GET_OFERTAS_WEB,
  CHECK_OFERTAS_WEB,
  SET_OFERTA_VALIDADA,
  GET_PEDIDO_ACTIVO,
} from './types'
import { tokenConfig } from './auth'
import i18n from '../lang/idiomas'

// GET ARTICULOS
export const getOfertas = () => (dispatch, getState) => {
  dispatch({
    type: FETCH_OFERTAS_WEB,
    payload: true,
  })
  axios
    .get(`/ofertasWeb`, tokenConfig(getState))
    .then(res => {
      // console.log("----> Respuesta ofertasWeb...")
      console.log(res)
      dispatch({
        type: GET_OFERTAS_WEB,
        payload: res.data,
      })
    })
    .catch(err => console.log(err))
}
export const checkOferta =
  (oferta, actualizar = 'N') =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_OFERTAS_WEB,
      payload: true,
    })
    console.log('Actions: ', oferta)
    let body = oferta
    axios
      .post(`/ofertasWeb/`, body, tokenConfig(getState))
      .then(res => {
        console.log('Respuesta check_ofertasWeb...', res.data)
        console.log('respuesta: ', res.data.respuesta)
        if (res.data.respuesta === 'OK') {
          dispatch(createMessage(i18n.t('ofertas.crsucss'), 'success'))
          dispatch({
            type: GET_PEDIDO_ACTIVO,
            payload: res.data.lineas,
          })
        } else {
          if (res.data.respuesta[0] === 'MALSTOCK') {
            dispatch(createMessage(i18n.t('ofertas.nostckre'), 'error'))
          }
          if (res.data.respuesta[0] === 'NO_REGALO') {
            dispatch(createMessage(i18n.t('ofertas.nosufun'), 'error'))
          }
          if (res.data.respuesta[0] === 'NOCONDI') {
            dispatch(createMessage(i18n.t('ofertas.nocucon'), 'error'))
          }
          if (res.data.respuesta[0] === 'NO_PRECIO') {
            dispatch(createMessage(i18n.t('ofertas.onorep'), 'error'))
          }
        }
        dispatch({
          type: CHECK_OFERTAS_WEB,
          payload: res.data.respuesta,
        })
      })
      .catch(err => {
        console.log(err)
        dispatch(createMessage(i18n.t('general.haocerr'), 'error'))
      })
  }

export const setOfertaValidada = () => (dispatch, getState) => {
  dispatch({
    type: SET_OFERTA_VALIDADA,
    payload: 'no_ok',
  })
}
